import { Banner } from '~types/ranking';

export const BANNERS: Banner[] = [
  {
    title: '원티드 AI',
    list_web: '이력서만 등록해도 나에게 딱 맞는 포지션 추천!',
    list_mobile: '이력서만 등록해도 나에게 딱 맞는\n포지션 추천!',
    side_web: '이력서만 등록해도 나에게\n딱 맞는 포지션 추천!',
    side_mobile: '이력서만 등록해도 나에게 딱 맞는\n포지션 추천!',
    image: 'https://image.wanted.co.kr/kreditjob/www/banner_1.jpg',
    landingUrl: 'https://www.wanted.co.kr/aiscore/resume',
    color: '#FBF0E7',
    eventId: 'wanted_AI',
  },
  {
    title: '원티드 이력서',
    list_web: '합격률 높은 원티드 이력서, 쉽고 빠르게 작성해보세요',
    list_mobile: '합격률 높은 원티드 이력서, 쉽고\n빠르게 작성해보세요',
    side_web: '합격률 높은 원티드 이력서,\n쉽고 빠르게 작성해보세요',
    side_mobile: '합격률 높은 원티드 이력서, 쉽고\n빠르게 작성해보세요',
    image: 'https://image.wanted.co.kr/kreditjob/www/banner_2.jpg',
    landingUrl: 'https://www.wanted.co.kr/cv/intro',
    color: '#F4EFF6',
    eventId: 'wanted_resume',
  },
  {
    title: '이직 준비',
    list_web: '요즘 핫한 이직 정보, 원티드에서 만나보세요',
    list_mobile: '요즘 핫한 이직 정보, 원티드에서\n만나보세요',
    side_web: '요즘 핫한 이직 정보,\n원티드에서 만나보세요',
    side_mobile: '요즘 핫한 이직 정보, 원티드에서\n만나보세요',
    image: 'https://image.wanted.co.kr/kreditjob/www/banner_3.jpg',
    landingUrl: 'https://www.wanted.co.kr/wdlist',
    color: '#E7F6F4',
    eventId: 'wanted_position',
  },
  {
    title: '채용 고민 해결!',
    list_web: '우리 기업에 딱 맞는 인재, 원티드에서 찾아보세요',
    list_mobile: '우리 기업에 딱 맞는 인재, 원티드에서\n찾아보세요',
    side_web: '우리 기업에 딱 맞는 인재,\n원티드에서 찾아보세요',
    side_mobile: '우리 기업에 딱 맞는 인재, 원티드에서\n찾아보세요',
    image: 'https://image.wanted.co.kr/kreditjob/www/banner_4.jpg',
    landingUrl: 'https://www.wanted.co.kr/dashboard/welcome',
    color: '#EBF9EC',
    eventId: 'wanted_company_dashboard',
  },
  {
    title: '이력서를 부탁해',
    list_web: '서류 합격률 높이고 싶다면? 원티드가 알려주는 이력서 작성 비법',
    list_mobile: '서류 합격률 높이고 싶다면? 원티드가\n알려주는 이력서 작성 비법',
    side_web: '서류 합격률 높이고 싶다면?\n원티드가 알려주는 이력서\n작성 비법',
    side_mobile: '서류 합격률 높이고 싶다면? 원티드가\n알려주는 이력서 작성 비법',
    image: 'https://image.wanted.co.kr/kreditjob/www/banner_5.jpg',
    landingUrl: 'https://www.wanted.co.kr/events/resume_contents',
    color: '#FFEFF4',
    eventId: 'wanted_event_resume',
  },
  {
    title: '원티드긱스',
    list_web: '매칭부터 계약 관리까지, 프리랜서 전문 플랫폼',
    list_mobile: '매칭부터 계약 관리까지, 프리랜서\n전문 플랫폼',
    side_web: '매칭부터 계약 관리까지,\n프리랜서 전문 플랫폼',
    side_mobile: '매칭부터 계약 관리까지, 프리랜서\n전문 플랫폼',
    image: 'https://image.wanted.co.kr/kreditjob/www/banner_7.jpg',
    landingUrl: 'https://www.wanted.co.kr/gigs/experts',
    color: '#E9F2FE',
    eventId: 'wanted_gigs',
  },
];
